import { render, staticRenderFns } from "./CardListItem.vue?vue&type=template&id=f4dd69a6"
import script from "./CardListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardListItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports